// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tta8T","title":"styles_title__2Jwc2","header":"styles_header__1S88f","avatar":"styles_avatar__RfaGP"};